/* Boost V2 — Live social proof.  v1.0.0 — 21 May 2026.
   - REAL live-viewer count via Supabase Realtime PRESENCE on a public channel boost:product:{id}.
     Shows ONLY when >= 2 real viewers. Never a random / fake number. Auto-clears on tab close.
   - "X sold" can be manually controlled with the product metafield custom.sales_proof_count.
     If no manual number is set, it uses the REAL Atlas aggregate storefront_product_live_stats
     (computed from real shopify_orders, refreshed every 30 min by cron). Read-only via REST.
   Loads supabase-js lazily (PDP only) from a bundled theme asset — no external CDN dependency.
   Truthfulness is non-negotiable: manual numbers are deliberate team-controlled overrides;
   otherwise every number shown here is real. */
(function () {
  'use strict';

  var SUPABASE_URL = 'https://zpefopnpabbgvldtvpka.supabase.co';
  var ANON_KEY = 'sb_publishable_CWjaAfrZ0ZxVNMBwQBMQVA_rRxwkCiH';
  window.BOOST_PUBLIC_SUPABASE_CONFIG = Object.freeze({
    url: SUPABASE_URL,
    anonKey: ANON_KEY
  });
  var MIN_VIEWERS = 2;   /* never show "1 viewing" — only genuine concurrency */
  var MIN_RECENT = 15;   /* floor for the recent-window number */
  var MIN_LIFETIME = 25; /* floor for the lifetime fallback ("X sold") */

  var root = document.querySelector('[data-boost-liveproof]');
  if (!root) return;                              /* not a product page */
  var productId = (root.getAttribute('data-product-id') || '').trim();
  if (!productId || productId === '0') return;

  var viewingWrap = root.querySelector('[data-boost-viewing]');
  var viewingText = root.querySelector('[data-boost-viewing-text]');
  var soldWrap    = root.querySelector('[data-boost-sold]');
  var soldText    = root.querySelector('[data-boost-sold-text]');
  var manualSoldRaw = (root.getAttribute('data-manual-sold-count') || '').trim();
  var manualSoldLabel = (root.getAttribute('data-manual-sold-label') || 'sold recently').trim() || 'sold recently';

  var tabId = 'v_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  var shownCount = 0;
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() { root.removeAttribute('hidden'); }
  function show(el) { if (el) el.removeAttribute('hidden'); }
  function hide(el) { if (el) el.setAttribute('hidden', ''); }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }

  /* Gentle integer tween so the count never jumps abruptly */
  function tween(el, from, to, dur) {
    if (!el) return;
    if (prefersReduced || from === to) { el.textContent = String(to); return; }
    var start = 0;
    function step(now) {
      if (!start) start = now;
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = String(Math.round(from + (to - from) * eased));
      if (t < 1) requestAnimationFrame(step); else el.textContent = String(to);
    }
    requestAnimationFrame(step);
  }

  /* === 1) Real "sold" count (REST, read-only aggregate).
     Honest tiering: recent window -> "X sold recently"; else lifetime total -> "X sold"; else hidden. === */
  function showSoldLabel(count, label) {
    if (!count || count < 1 || !soldText) return false;
    soldText.innerHTML = '<b class="bpdp-liveproof-count">' + count.toLocaleString('en-US') +
      '</b> <span>' + escapeHtml(label || 'sold recently') + '</span>';
    show(soldWrap);
    reveal();
    return true;
  }

  function loadSold() {
    if (!window.fetch) return;
    var manualCount = parseInt(manualSoldRaw.replace(/[^\d]/g, ''), 10);
    if (manualCount > 0 && showSoldLabel(manualCount, manualSoldLabel)) return;
    var url = SUPABASE_URL + '/rest/v1/storefront_product_live_stats?product_id=eq.' +
              encodeURIComponent(productId) + '&select=units_recent,units_lifetime';
    fetch(url, { headers: { apikey: ANON_KEY, Authorization: 'Bearer ' + ANON_KEY }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (rows) {
        var row = (rows && rows[0]) || {};
        var recent = row.units_recent || 0;
        var life   = row.units_lifetime || 0;
        var label = '';
        if (recent >= MIN_RECENT)      label = 'sold recently';
        else if (life >= MIN_LIFETIME) label = 'sold';
        if (label) showSoldLabel(recent >= MIN_RECENT ? recent : life, label);
      })
      .catch(function () { /* quiet — sold line just stays hidden */ });
  }

  /* === 2) Real live viewers (Supabase Realtime presence) === */
  function renderViewers(count) {
    /* SUBHAN-D4 hygiene: the viewing-text element was removed 30 May (Chief) — presence syncs were null-crashing here ever since */
    if (!viewingText) return;
    if (count >= MIN_VIEWERS) {
      var numEl = viewingText && viewingText.querySelector('[data-boost-count]');
      if (!numEl) {
        viewingText.innerHTML = '<b class="bpdp-liveproof-num" data-boost-count>' + count +
          '</b> people are viewing this right now';
        shownCount = count;
      } else {
        tween(numEl, shownCount, count, 600);
        shownCount = count;
      }
      if (viewingText) { show(viewingWrap); reveal(); }
    } else {
      hide(viewingWrap);
    }
  }

  function loadLib(src) {
    return new Promise(function (resolve, reject) {
      if (window.supabase && window.supabase.createClient) return resolve(window.supabase);
      if (!src) return reject(new Error('no lib src'));
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function () {
        if (window.supabase && window.supabase.createClient) resolve(window.supabase);
        else reject(new Error('supabase global missing after load'));
      };
      s.onerror = function () { reject(new Error('lib load failed')); };
      document.head.appendChild(s);
    });
  }

  function initPresence() {
    var src = root.getAttribute('data-sb-src');
    loadLib(src).then(function (lib) {
      var sb = lib.createClient(SUPABASE_URL, ANON_KEY);
      var channel = sb.channel('boost:product:' + productId, { config: { presence: { key: tabId } } });
      function sync() { renderViewers(Object.keys(channel.presenceState()).length); }
      channel
        .on('presence', { event: 'sync' }, sync)
        .on('presence', { event: 'join' }, sync)
        .on('presence', { event: 'leave' }, sync)
        .subscribe(function (status) {
          if (status === 'SUBSCRIBED') { channel.track({ at: Date.now() }); }
        });
      function cleanup() {
        try { channel.untrack(); } catch (e) {}
        try { sb.removeChannel(channel); } catch (e) {}
      }
      window.addEventListener('pagehide', cleanup);
      window.addEventListener('beforeunload', cleanup);
    }).catch(function () { /* presence unavailable — sold count still shows */ });
  }

  loadSold();
  initPresence();
})();
